import styled from '@emotion/styled';
import React from 'react';
import { connect } from 'react-redux';

import ComponentOptionsTable from '../../../shared/ComponentOptionsTable';
import YesNoTable from '../../../shared/YesNoTable/index.jsx';
import { BackArrow } from '../../../shared/svgIcons.jsx';
import { incrementStep, decrementStep } from '../../redux/actions';

const StepWrapper = styled.div`
  max-width: 23.125rem;
  width: 100%;
`;

const IntroMessage = styled.p`
  font-weight: 400;
  font-size: 16px;
  line-height: 18px;
  color: #333333;
`;

const Header = styled.h3`
  font-family: 'OCRoboto';
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: 22px;
  padding-top: 1rem;
  text-transform: none;
`;

const NextButton = styled.button`
  background-color: #d40f7d;
  border: none;
  color: #ffffff;
  cursor: pointer;
  font-size: 18px;
  padding: 0.5rem;
  width: 100%;
  margin-top: 1.5rem;
  :disabled {
    background-color: #d8d8d8;
    cursor: default;
  }
`;

const BackWrapper = styled.div`
  align-items: center;
  cursor: pointer;
  color: #333333;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding-top: 2rem;
  width: 100%;

  h3 {
    font-weight: 700;
    font-size: 16px;
    color: #000;
    text-transform: uppercase;
    font-family: 'OCRoboto';
  }
`;

const BackText = styled.p`
  margin-top: 0.5rem;
  padding-bottom: 1.5rem;
  text-align: center;
  font-size: 12px;
`;

const InputWrapper = styled.div`
  width: 100%;
  padding: 0.5em 0;
`;

const mapStateToProps = state => ({
  formData: state.formData,
});

const ContractorStep11 = ({ incrementStep, decrementStep }) => {
  const validated = true;

  return (
    <StepWrapper>
      <BackWrapper
        data-track="form-back"
        data-track-form-name="Warranty Registration"
        data-track-form-step="step 12 - did you have any OwensCorning components"
        onClick={decrementStep}
      >
        <BackArrow width="21" height="12" />
        <h3>Back</h3>
        <BackText>Can you describe the type of shingles you installed?</BackText>
      </BackWrapper>
      <IntroMessage>That’s a great choice!</IntroMessage>
      <Header>Did you install any Owens Corning components?</Header>
      <InputWrapper>
        <ComponentOptionsTable />
      </InputWrapper>
      <NextButton
        data-track="form-advance"
        data-track-form-name="Warranty Registration"
        data-track-form-step="step 12 - did you have any OwensCorning components"
        onClick={incrementStep}
        disabled={!validated}
      >
        Next
      </NextButton>
    </StepWrapper>
  );
};

const mapDispatchToProps = dispatch => ({
  incrementStep: () => dispatch(incrementStep()),
  decrementStep: () => dispatch(decrementStep()),
});

export default connect(mapStateToProps, mapDispatchToProps)(ContractorStep11);
